import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => ({ task }) => {
  const { list_id } = hooks.useParams()
  const navigate = hooks.useNavigate()
  const [, { openDialog }] = hooks.useDialogs()

  const total = hooks.useSearchListenerCount('order', 'list_orders')
  const created = hooks.useSearchListenerCount('order', 'list_orders_created')

  const [list] = hooks.useModel('list', [list_id], { single: true })
  const list_client_id = list?.list_client_id

  const onCancelList = useCallback(Callbacks.cancelListHandler(list_client_id, openDialog), [list_client_id, openDialog])
  const onClickReturn = useCallback(() => navigate(-1), [navigate])

  const isComplete = task?.status === 'complete'

  const import_total = _.size(task?.input?.orders)

  const mergedProps = {
    list_client_id,
    import_total,
    created,
    total,
    isComplete,
    onClickReturn,
    onCancelList,
    task
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
